import { render } from "./Home.vue?vue&type=template&id=130d9c2e&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=130d9c2e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\dinho\\Documents\\GitHub\\Grajaú-E-SPORTS\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130d9c2e"]])

export default __exports__